<template>
  <UiBtn
    v-show="!isLoggedIn"
    class="base-login"
    color="default"
    :text="$tc('logInBtn.title')"
    :size="size"
    :size-small-mobile="sizeSmallMobile"
    @click="openRegModal"
  />
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BaseLogin',
  props: {
    size: { type: [String, Object], default: 'm' },
    sizeSmallMobile: { type: Boolean },
  },
  computed: {
    ...mapGetters('user', { isLoggedIn: 'isLoggedIn' }),
  },
  methods: {
    openRegModal() {
      this.$newModal.openAuthWithLastMethod()
    },
  },
}
</script>
<style lang="scss" scoped>
  .base-login {
    width: 100px;

    @include media(tablet) {
      width: auto;
    }
  }
</style>
